import { apiV2, errorHandler } from "./index";
import { API_ERROR, FETCH_ALL_PERMISSIONS, FETCH_ALL_PERMISSIONS_ERROR, FETCH_ALL_PERMISSIONS_SUCCESS } from "../constants/ActionTypes";

export function fetchAllPermissions() {
  return function (dispatch) {
    dispatch({
      type: FETCH_ALL_PERMISSIONS
    });

    apiV2.get('/admin-permissions')
      .then((response) => {
        dispatch({
          type: FETCH_ALL_PERMISSIONS_SUCCESS,
          payload: response.data.permissions || response.data.objects || response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ALL_PERMISSIONS_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      })
  }
}
